/* eslint-disable no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import _ from 'lodash';
import './styles/homescreen.css';
import homeScreenConfig from '../utils/homescreen';
import { parseQueryString, isDesktopScreen } from '../utils/utils';
import { firePageNavigationEvent } from '../utils/events';
import useTranslation from '../hooks/use-translation';
import getSource from '../utils/get-source';
import BannerIcon from "../images/BannerIcon.svg"
import UnlockCorporateServicesBanner from "../images/UnlockCorporateServicesBanner.svg"
import * as Ms from '@microsoft/teams-js';
import { gtag } from "../utils/gtm-util";
import LinkCorporateModal from "./LinkCorporateModal";
import { _getPartnerIds, _associateJhhPartnerApiCall, _getPartnerDiscoveryApiCall, _getCorporateServicesApiCall, _getServicesJsonFromS3ApiCall } from "../utils/Network/partnerOnBoarding";
import { _getItemFromLocalDecrypted } from "network-helper";
import { _getItemFromLocal, _removeItemFromLocal, _setItemInLocal } from "../utils/LocalKeys";
import { raiseGAEvent } from '../utils/network';
import { Icon, Skeleton, Text } from '@jds/core';
import { IcNextCircle } from '@jds/extended-icons';
import { _isCorporateLinked } from '../utils/isCorporateLinked';
import SampleServiceMapJson from "../JSONS/REPLICA/ril/exclusiveServicesMap.json"

const sampleCorporateServices = {
  "message": "success",
  "data": [
      {
          "corporateId": 254,
          "authId": "Jio",
          "name": "Jio Platforms Limited",
          "services": [
              {
                  "id": "1",
                  "name": "Periodic Medical Examination (PME)"
              }
          ]
      },
      {
          "corporateId": 79,
          "authId": "ril",
          "name": "Reliance Industries Limited",
          "services": [
              {
                  "id": "3",
                  "name": "Corporate Doctor Consult"
              },
              {
                  "id": "4",
                  "name": "Emotional Wellness"
              },
              {
                  "id": "6",
                  "name": "Emergency Services"
              },
              {
                  "id": "1",
                  "name": "Periodic Medical Examination (PME)"
              }
          ]
      }
  ]
}

const getSourceId = async () => {
  const { source_id } = parseQueryString();
  if (source_id) {
    return Promise.resolve(source_id);
  }
  const sourceData = await getSource();
  return sourceData.source_id;
}

export default () => {
  const [state, setState] = useState({
    source_id: undefined
  })
  const { push } = useHistory();
  const { t } = useTranslation();
  const [showLinkModal, _setShowLinkModal] = useState(false);
  const [showExclusives, setShowExclusives] = useState(false);
  const [showExclusivesLoader, setShowExclusivesLoader] = useState(false);
  const [exclusiveServicesList, setExclusiveServicesList] = useState([]);

  const redirectTo = useCallback(path => async () => {
    if (path.indexOf("http") > -1) {
      if (path.indexOf("avighna") > -1) {
        raiseGAEvent("AVIGHNA", "Clicked", "Avighna_hometile");
      }
      window.location = path;
    } else {
      push(path);
      firePageNavigationEvent(path);
    }
  }, [push]);

  const _closeLinkModal = () => {
    _setShowLinkModal(false);
    _removeItemFromLocal("showLinkMsgType");
  }

  useEffect(() => {
    const msgType = _getItemFromLocal("showLinkMsgType");
    if (msgType) {
      _setShowLinkModal(true);
    }

    function gtag() { window.dataLayer.push(arguments); }
    gtag('event', 'page_view', {
      page_title: 'Homepage',
      page_location: '/homepage',
      page_path: window.location.pathname,
      page_referrer: 'https://healthhub.jio.com'
    })

    getSourceId()
      .then(source_id => {
        setState(prevState => ({
          ...prevState,
          source_id
        }));
      })

    _checkCorporate()
  }, [])

  const source_id = state.source_id;

  const handleDeepLink = (tabId, name) => {
    const GAObject = {
      "new_Action": t(name)
    }
    // console.log(t(name), state.source_id, source_id, tabId);
    // raiseGAEventTeams(GAObject)
    const eventAction = t(name);
    gtag(
      "Teams Signed in Dashboard",
      eventAction,
      "",
      ""
    )
    Ms.initialize()
    Ms.executeDeepLink(
      "https://teams.microsoft.com/l/entity/" + tabId
    );
  }

  const _getServiceMapJson = async (partnerId) => {
    try {
      let newServiceMapJson = {};
      const pathPrefix = partnerId ? `/${partnerId}` : "";
      try {
        newServiceMapJson = await _getServicesJsonFromS3ApiCall(`${pathPrefix}/exclusiveServicesMap.json`);
      } catch (error) {
        try {
          newServiceMapJson = await _getServicesJsonFromS3ApiCall(`/ril/exclusiveServicesMap.json`);
        } catch (error) {
          // notify(_.get(error, "response.data.message", fallbackErrorMessage))
        }
      }
      // const newServiceMapJson = SampleServiceMapJson;
      return newServiceMapJson;
    } catch (error) {
      
    }
  }

  const _checkCorporate = async () => {
    try {
      setShowExclusivesLoader(true);
      const currentProfile = _getItemFromLocalDecrypted("_cp");
      const currentProfileDetails = JSON.parse(currentProfile);
      let jhhId = currentProfileDetails.jio_id;
      if(jhhId) {
        const corporateDetails = await _isCorporateLinked()
        if(_.get(corporateDetails, "linked", false)) {
          const partnerId = _.get(corporateDetails, "partner.partner_id", "")
          const payloadPartnerDiscovery = {
            body_array: JSON.stringify([
              {
                "partner_user_id": _.get(corporateDetails, "partner.meta_fields.partner_user_id", ""),
                "partner_id": partnerId
              }
            ]),
          };
          const partnerDetailResponse = await _getPartnerDiscoveryApiCall(payloadPartnerDiscovery);
          const businessGroup = _.get(partnerDetailResponse, "contents[0].partner_user.meta_fields.business_group", "")
          const dataObj = {
            "authId": [partnerId, businessGroup]
          }
          const newCorporateServices = await _getCorporateServicesApiCall(dataObj)
          const newCorporateServicesParsed = JSON.parse(newCorporateServices)
          // const newCorporateServicesData = _.get(sampleCorporateServices, "data", []);
          const newCorporateServicesData = _.get(newCorporateServicesParsed, "data", []);
          const newCorporateServicesIds = []
          newCorporateServicesData.forEach((data) => {
            const services = _.get(data, "services", [])
            services.forEach((service) => {
              newCorporateServicesIds.push(_.get(service, "id"))
            })
          })
          const newCorporateServicesIdsUnique = [...(new Set(newCorporateServicesIds))]
          const newServiceMapJson = await _getServiceMapJson(partnerId)
          const newExclusiveServicesList = []
          newCorporateServicesIdsUnique.forEach((id) => {
            const newServiceData = _.get(newServiceMapJson, id);
            if(newServiceData) {
              newExclusiveServicesList.push(newServiceData)
            }
          })
          newExclusiveServicesList.sort((a,b) => (_.get(a, "orderIndex") - _.get(b, "orderIndex")))
          setExclusiveServicesList(newExclusiveServicesList);
          setShowExclusives(true)
        } else {
          setShowExclusives(false)
        }
      }
    } catch (error) {
      setShowExclusives(false)
    } finally {
      setShowExclusivesLoader(false)
    }
  }

  const _onServiceClick = (redirectTo) => {
    window.location.href = `${window.location.origin}${redirectTo}`
  }

  const styleClassForHeader = (state.source_id && (state.source_id === 'JioHealthHub' ||
    state.source_id === 'MyJio' || state.source_id === "JhhWebApp")) ? 'paddingTopSmall' : '';

  const homepageMobile = () => (
    <div className="home-screen-view-desktop-container">
      <div className="home-screen-logo-container"><img src={BannerIcon} className="home-screen-logo" alt="corporate offers"/></div>
      <div>
        <ListGroup className="home-screen-options-container">
          {
            (
              source_id === "MS_Teams" ?
                homeScreenConfig.ril_available_options
                : source_id === "MS_Teams_Public" ?
                  homeScreenConfig.public_available_options
                  : homeScreenConfig.available_options
            ).map((item, index) => (
              <ListGroup.Item
                className={`home-screen-grid-container ${index % 2 === 0 ? 'home-screen-grid-container-no-left-margin' : 'home-screen-grid-container-no-right-margin'}`}
                key={item.name}
                // action
                onClick={(source_id === "MS_Teams" || source_id === "MS_Teams_Public") ? () => handleDeepLink(item.tabId, item.name) : redirectTo(item.navigateTo)}
              >
                <div className="home-screen-grid-main-div">
                  <div>
                    <img src={item.icon} className="home-screen-grid-icon" alt={`${item?.name}`}/>
                  </div>
                  <div className="home-screen-grid-name">
                    {t(item.name) || item.name}
                  </div>
                  <div className="home-screen-grid-description">
                    {t(item.description) || item.description}
                  </div>
                </div>
              </ListGroup.Item>
            ))
          }
        </ListGroup>
      </div>
    </div>
  );

  const renderMobile = () => {
    return homepageMobile();
  };

  const renderDesktop = () => (
    <div className="home-screen-view-desktop-container">
      {
        showExclusivesLoader
        ? <Skeleton className="home-screen-exclusives-loader" />
        : showExclusives
          ? <div className='home-screen-exclusives-div'>
              <Text className='home-screen-exclusives-title' children="Exclusively For You" appearance='heading-xs' color='primary-grey-100' />
              <div className='home-screen-exclusives-list'>
                {
                  exclusiveServicesList.map((service, index = 0) => 
                    <div key={index} className='home-screen-exclusives-list-item' onClick={() => {_onServiceClick(_.get(service, "redirectTo"))}}>
                      <img src={_.get(service, "bannerImg", "")} alt={_.get(service, "title", "")} />
                    </div> 
                  )
                }
              </div>
              <div className='home-screen-exclusives-arrows'>
                <Icon ic={<IcNextCircle />} className='home-screen-exclusives-arrow left' size='xxl' />
                <Icon ic={<IcNextCircle />} className='home-screen-exclusives-arrow' size='xxl' />
              </div>
            </div>
          : <div className="home-screen-logo-container"><img src={UnlockCorporateServicesBanner} alt="corporate offers" className="home-screen-logo" onClick={()=>{window.location.href = `${window.location.origin}/manage-identity/?redirect_url=/`}} /></div>
      }
      <div>
        <ListGroup className="home-screen-options-container">
          {
            (
              source_id === "MS_Teams" ?
                homeScreenConfig.ril_available_options
                : source_id === "MS_Teams_Public" ?
                  homeScreenConfig.public_available_options
                  : homeScreenConfig.available_options
            ).map((item, index) => (
              <ListGroup.Item
                className={`home-screen-grid-container ${index % 4 === 0 ? 'home-screen-grid-container-no-left-margin' : ''} ${index % 4 === 3 ? 'home-screen-grid-container-no-right-margin' : ''} `}
                key={item.name}
                // action
                onClick={(source_id === "MS_Teams" || source_id === "MS_Teams_Public") ? () => handleDeepLink(item.tabId, item.name) : redirectTo(item.navigateTo)}
              >
                <div className="home-screen-grid-main-div">
                  <div>
                    <img src={item.icon} className="home-screen-grid-icon" alt={`${item?.name}`} />
                  </div>
                  <div className="home-screen-grid-name">
                    {t(item.name) || item.name}
                  </div>
                  <div className="home-screen-grid-description">
                    {t(item.description) || item.description}
                  </div>
                </div>
              </ListGroup.Item>
            ))
          }
        </ListGroup>
      </div>
    </div>
  );
  return (
    <>
      {showLinkModal && <LinkCorporateModal showLinkMsgType={_getItemFromLocal("showLinkMsgType")} _closeLinkModal={_closeLinkModal} />}
      {isDesktopScreen() ? renderDesktop() : renderMobile()}
    </>
  );
};
